import { render } from "./HomeFooter.vue?vue&type=template&id=4d363b4a"
const script = {}

import "./HomeFooter.vue?vue&type=style&index=0&id=4d363b4a&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__